import createAxios, { storeApiPluginHOM, getHOM, postHOM, putHOM, deleteHOM, patchHOM } from '@/global/http';
import { BASE_URL } from '@/global/util/constants';
import { errorCaptured } from '@/global/util/util';
import router from '../router';

const axios = createAxios(
  {
    baseURL: BASE_URL
  },
  router
  // store
);

export const get = getHOM(axios);
export const post = postHOM(axios);
export const put = putHOM(axios);
export const remove = deleteHOM(axios);
export const patch = patchHOM(axios);
export const storeApiPlugin = storeApiPluginHOM(axios);
export const capturedGet = async (...args) => await errorCaptured(async () => await get(...args))
export const capturedPost = async (...args) => await errorCaptured(async () => await post(...args))
export const capturedPut = async (...args) => await errorCaptured(async () => await put(...args))
export const capturedRemove = async (...args) => await errorCaptured(async () => await remove(...args))
export const capturedPatch = async (...args) => await errorCaptured(async () => await patch(...args))

export default axios;
